// Structured Response Components Index
// This module exports all structured response components that can be rendered by AI agents

import StructuredTable from './StructuredTable.js';
import StructuredForm from './StructuredForm.js';
import StructuredImage from './StructuredImage.js';
import StructuredLink from './StructuredLink.js';
import StructuredCard from './StructuredCard.js';
import StructuredList from './StructuredList.js';
import StructuredChart from './StructuredChart.js';
import StructuredRenderer from './StructuredRenderer.js';

// Export all components
export {
  StructuredTable,
  StructuredForm,
  StructuredImage,
  StructuredLink,
  StructuredCard,
  StructuredList,
  StructuredChart,
  StructuredRenderer,
};

// Component registry for dynamic rendering
export const STRUCTURED_COMPONENTS = {
  table: StructuredTable,
  form: StructuredForm,
  image: StructuredImage,
  link: StructuredLink,
  card: StructuredCard,
  list: StructuredList,
  chart: StructuredChart,
};

// Schema for structured responses
export const STRUCTURED_RESPONSE_SCHEMA = {
  type: 'object',
  properties: {
    type: {
      type: 'string',
      enum: ['text', 'structured', 'mixed'],
      description: 'Type of response',
    },
    content: {
      type: 'string',
      description: 'Text content for text or mixed responses',
    },
    components: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          type: {
            type: 'string',
            enum: ['table', 'form', 'image', 'link', 'card', 'list', 'chart'],
            description: 'Component type to render',
          },
          props: {
            type: 'object',
            description: 'Props to pass to the component',
          },
          id: {
            type: 'string',
            description: 'Unique identifier for the component',
          },
        },
        required: ['type', 'props'],
      },
      description: 'Array of structured components to render',
    },
  },
  required: ['type'],
};
